export const LoadingDots = () => (
    <span className='flex items-center gap-[3px]'>
        <span className='inline-block size-[3px] rounded-full bg-gray-400 animate-chat-dot-bounce' />
        <span className='inline-block size-[3px] rounded-full bg-gray-400 animate-chat-dot-bounce [animation-delay:0.2s]' />
        <span className='inline-block size-[3px] rounded-full bg-gray-400 animate-chat-dot-bounce [animation-delay:0.4s]' />
    </span>
);
